module.exports = __webpack_public_path__ + "media/images/flags/pt-1404e490bc4ef4e6c2ed5de118578c38.svg";